import { useContext } from '@wordpress/element';

import UserContext from '../context/context';

const ClassChart = () => {
    const context = useContext(UserContext);
    const { selectedClassData } = context;

    return (
        <>
            <div id="class_chart">
                <object
                 >
                    <img src={selectedClassData.static_chart_png} />
                </object>
            </div>

            <div id="class_chart_wide">
                <object
                 >
                    <img src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-middle-class-metro-map/MiddleIncome_RightChart_Middle_760px.png" />
                </object>
            </div>
        </>
    );
};

export default ClassChart;
